import { fallbackFontFamily } from './constants';
export const makeMed5 = (tokens, contextual) => ({
    fontWeight: tokens.TextBodyMedium5FontWeight,
    fontSize: tokens.TextBodyMedium5FontSize,
    fontFamily: `${tokens.TextBodyMedium5FontFamily}, ${fallbackFontFamily}`,
    lineHeight: tokens.TextBodyMedium5LineHeight,
    ...contextual,
});
export const makeMed4 = (tokens, contextual) => ({
    fontWeight: tokens.TextBodyMedium4FontWeight,
    fontSize: tokens.TextBodyMedium4FontSize,
    fontFamily: `${tokens.TextBodyMedium4FontFamily}, ${fallbackFontFamily}`,
    lineHeight: tokens.TextBodyMedium4LineHeight,
    ...contextual,
});
export const makeReg4 = (tokens, contextual) => ({
    fontWeight: tokens.TextBodyReg4FontWeight,
    fontSize: tokens.TextBodyReg4FontSize,
    lineHeight: tokens.TextBodyReg4LineHeight,
    fontFamily: `${tokens.TextBodyReg4FontFamily}, ${fallbackFontFamily}`,
    ...contextual,
});
export const makeReg5 = (tokens, contextual) => ({
    fontWeight: tokens.TextBodyReg5FontWeight,
    fontSize: tokens.TextBodyReg5FontSize,
    lineHeight: tokens.TextBodyReg5LineHeight,
    fontFamily: `${tokens.TextBodyReg5FontFamily}, ${fallbackFontFamily}`,
    ...contextual,
});
export const makeReg6 = (tokens, contextual) => ({
    fontWeight: tokens.TextBodyReg6FontWeight,
    fontSize: tokens.TextBodyReg6FontSize,
    lineHeight: tokens.TextBodyReg6LineHeight,
    fontFamily: `${tokens.TextBodyReg6FontFamily}, ${fallbackFontFamily}`,
    ...contextual,
});
export const makeReg3 = (tokens, contextual) => ({
    fontWeight: tokens.TextBodyReg3FontWeight,
    fontSize: tokens.TextBodyReg3FontSize,
    lineHeight: tokens.TextBodyReg3LineHeight,
    fontFamily: `${tokens.TextBodyReg3FontFamily}, ${fallbackFontFamily}`,
    ...contextual,
});
export const makeReg2 = (tokens, contextual) => ({
    fontWeight: tokens.TextBodyReg2FontWeight,
    fontSize: tokens.TextBodyReg2FontSize,
    lineHeight: tokens.TextBodyReg2LineHeight,
    fontFamily: `${tokens.TextBodyReg2FontFamily}, ${fallbackFontFamily}`,
    ...contextual,
});
export const makeMed3 = (tokens, contextual) => ({
    fontWeight: tokens.TextBodyMedium3FontWeight,
    fontSize: tokens.TextBodyMedium3FontSize,
    fontFamily: `${tokens.TextBodyMedium3FontFamily}, ${fallbackFontFamily}`,
    lineHeight: tokens.TextBodyMedium3LineHeight,
    ...contextual,
});
export const makeMed2 = (tokens, contextual) => ({
    fontWeight: tokens.TextBodyMedium2FontWeight,
    fontSize: tokens.TextBodyMedium2FontSize,
    fontFamily: `${tokens.TextBodyMedium2FontFamily}, ${fallbackFontFamily}`,
    lineHeight: tokens.TextBodyMedium2LineHeight,
    ...contextual,
});
export const makeLink3 = (tokens, contextual) => ({
    fontWeight: tokens.TextBodyLink3FontWeight,
    fontSize: tokens.TextBodyLink3FontSize,
    fontFamily: `${tokens.TextBodyLink3FontFamily}, ${fallbackFontFamily}`,
    lineHeight: tokens.TextBodyLink3LineHeight,
    ...contextual,
});
export const makeLink4 = (tokens, contextual) => ({
    fontWeight: tokens.TextBodyLink3FontWeight,
    fontSize: tokens.TextBodyLink3FontSize,
    fontFamily: `${tokens.TextBodyLink3FontFamily}, ${fallbackFontFamily}`,
    lineHeight: tokens.TextBodyLink3LineHeight,
    ...contextual,
});
const textStyles = (tokens) => {
    const focusStyles = {
        _focus: {
            shadow: 'none',
            outline: 'none',
        },
        _focusVisible: {
            outlineColor: tokens.BorderFocus,
            outlineWidth: tokens.BorderWidth02,
            shadow: `outset 0px 0px ${tokens.BorderWidth02} ${tokens.BorderWidth02} ${tokens.BorderFocus}`,
        },
    };
    return {
        variants: {
            'dk-800-md-4': makeMed4(tokens, {
                color: tokens.TextDark800,
            }),
            'dk-800-md-3': makeMed3(tokens, {
                color: tokens.TextDark800,
                ...focusStyles,
            }),
            'wt-100-md-3': makeMed3(tokens, {
                color: tokens.TextWhite100,
                ...focusStyles,
            }),
            'dk-800-rg-3': makeReg3(tokens, {
                color: tokens.TextDark800,
                ...focusStyles,
            }),
            'dk-800-rg-5': makeReg5(tokens, {
                color: tokens.TextDark800,
                ...focusStyles,
            }),
            'dk-800-rg-4': makeReg4(tokens, {
                color: tokens.TextDark800,
                ...focusStyles,
            }),
            'md-600-rg-4': makeReg4(tokens, {
                color: tokens.TextMedium600,
            }),
            'md-600-rg-6': makeReg6(tokens, {
                color: tokens.TextMedium600,
            }),
            'md-600-rg-3': makeReg3(tokens, {
                color: tokens.TextMedium600,
                ...focusStyles,
            }),
            'lt-500-rg-5': makeReg5(tokens, {
                color: tokens.TextLight500,
                ...focusStyles,
            }),
            'lt-500-rg-4': makeReg4(tokens, {
                color: tokens.TextLight500,
                ...focusStyles,
            }),
            'md-600-rg-5': makeReg5(tokens, {
                color: tokens.TextMedium600,
                ...focusStyles,
            }),
            'lt-500-rg-3': makeReg3(tokens, {
                color: tokens.TextLight500,
                ...focusStyles,
            }),
            'lt-500-rg-2': makeReg2(tokens, {
                color: tokens.TextLight500,
                ...focusStyles,
            }),
            'sidebar-item-selected': makeMed5(tokens, {
                color: tokens.PrimaryNavigationWebTextSelected,
            }),
            'sidebar-item-unselected': makeMed5(tokens, {
                color: tokens.PrimaryNavigationWebTextUnselected,
            }),
            'link-400-lk-3': makeLink3(tokens, {
                color: tokens.TextLink,
                ...focusStyles,
            }),
            'link-400-lk-4': makeLink4(tokens, {
                color: tokens.TextLink,
                ...focusStyles,
            }),
        },
    };
};
export default textStyles;
